<template>
  <div class="investor container">
    <div class="title">
      <span>Zealcomm</span>是一家YC (China) 公司，
      <br />
      并得到了顶级投资人的支持。
      <p>
        Zealcomm（上海峰畅信息科技有限公司）由国际顶尖⽹络⾳视频技术专家创⽴，以⾃主研发的云原⽣WebRTC实时视频平台为核⼼，通过流畅的⾳视频在线交互体验、开放的AI算法及业务场景接⼝、和⾏业独创的的⽆代码智能视频应⽤开发⼯具，打造新⼀代视频原⽣的企业信息化基础设施。
      </p>
    </div>

    <div class="investor-box">
      <div class="investor-txt">
        <p class="name">陆奇 <span class="company">（奇绩创坛）天使投资</span></p>
        <div class="introduce d-none d-md-block" style="max-width: 585px">
          奇绩创坛（原YC中国）创始人，前百度集团总裁及首席运营官，前微软全球执行副总裁，前雅虎执行副总裁
        </div>
        <div class="introduce mobile d-md-none">
          <p>奇绩创坛（原YC中国）创始人</p>
          <p>前百度集团总裁及首席运营官</p>
          <p>前微软全球执行副总裁</p>
          <p>前雅虎执行副总裁</p>
        </div>
      </div>
      <img class="photo d-none d-md-block" src="~assets/img/home/luqi.png" alt="" />
      <img class="photo d-md-none" src="~assets/img/about/luqi-m.png" alt="" />
    </div>
    <div class="company-box">
      <img class="company" src="https://zealcomm-site-assets.zealcomm.cn/about/company.png" />
    </div>
  </div>
</template>
<script>
  export default {
    props: {},
    data() {
      return {};
    },
    created() {},
    mounted() {},
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .title {
    margin-top: 120px;
    color: #333;
    font-size: 36px;
    text-align: center;

    span {
      color: $main-color;
    }
    p {
      color: #333;
      font-size: 18px;
      text-align: left;
      margin: 30px 0;
    }
  }

  .investor-box {
    margin: 50px auto 0;
    padding: 50px 60px 25px;
    max-width: 916px;
    border-radius: 10px;
    background: rgba(245, 245, 247, 1);

    @extend .flex-space-between;

    .investor-txt {
      .name {
        color: #333;
        font-size: 30px;
        font-weight: bold;

        span.company {
          font-size: 20px;
        }
      }

      .introduce {
        margin-top: 34px;
        color: #666;
        font-size: 24px;
      }
    }

    .photo {
      width: 163px;
    }
  }

  .company-box {
    margin: 50px auto 120px;
    text-align: center;

    img {
      max-width: 477px;
    }
  }

  @media screen and (max-width: 992px) {
  }

  @media screen and (max-width: 768px) {
    .title {
      margin-top: 50px;
      font-size: 18px;
      p {
        color: #333;
        font-size: 14px;
        text-align: left;
        margin: 22px 0;
      }
    }
    .investor-box {
      margin: 22px auto 0;
      padding: 32px 16px;
      max-width: 916px;

      @extend .flex-space-between;

      .investor-txt {
        .name {
          font-size: 16px;

          span.company {
            font-size: 13px;
          }
        }

        .introduce.mobile {
          margin-top: 18px;

          p {
            color: #666;
            font-size: 12px;

            &::before {
              content: "";
              display: inline-block;
              margin-right: 5px;
              width: 4px;
              height: 4px;
              background: rgba(153, 153, 153, 1);
            }
          }
        }
      }

      .photo {
        margin-bottom: -32px;
        width: 106px;
      }
    }

    .company-box {
      margin: 30px auto 50px;

      img {
        max-width: 251px;
      }
    }
  }
</style>
